import React from 'react';
import Calculator from "../../../../../../../auxiliary-components/Calculator";

export default function template() {
   const model = this.getModel();

    return (
      !model.creditSum ? (
        ''
      ) : (
        <div className='credit-calculator money-auto-calc'>
          <div className='content'>
            <Calculator
              model={this.getModel()}
              type={'money_auto'}
              {...this.props}
            />
          </div>
        </div>
      )
    );
}
